import { TICKS_PER_LOOP } from '@arpeggi/shared'
import { observer } from 'mobx-react-lite'
import { FC, useEffect, useLayoutEffect, useRef } from 'react'
import { styled } from '../../../../lib/stitches'
import { useTreeState } from '../../../../stores/Root'
import PianoRollStateManager from './PianoRollStateManager'
import { KEYBOARD_WIDTH } from './PianoRollUtils'

const PlayheadContainer = styled('div', {
  position: 'absolute',
  left: KEYBOARD_WIDTH,
  bottom: 0,
  top: 0,
  width: '1px',
  background: 'rgb(0,0,0)',
  userSelect: 'none',
  pointerEvents: 'none'
})

const Playhead: FC = () => {
  const { studio } = useTreeState()
  const { playheadVisiblePositionInTicks, currentSection, selectedSection } = studio
  const ref = useRef<HTMLDivElement>(null)
  const playheadX = playheadVisiblePositionInTicks % TICKS_PER_LOOP
  const isPlayheadVisible = currentSection === selectedSection
  useLayoutEffect(() => {
    PianoRollStateManager.subscribe('playhead', (state) => {
      ref.current.style.setProperty('transform', `translateX(${state.tickWidthPx * playheadX}px)`)
    })
    return () => PianoRollStateManager.unsubscribe('playhead')
  }, [])
  useEffect(() => {
    ref.current.style.setProperty('visibility', isPlayheadVisible ? 'visible' : 'hidden')
  }, [isPlayheadVisible])
  useEffect(() => {
    ref.current.style.setProperty(
      'transform',
      `translateX(${PianoRollStateManager.state.tickWidthPx * playheadX}px)`
    )
  }, [playheadX])

  return <PlayheadContainer ref={ref} />
}

export default observer(Playhead)
